
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 5 3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h5v3H0z"}}),_c('path',{attrs:{"fill":"#D00","d":"M0 1h5v2H0z"}}),_c('path',{attrs:{"fill":"#FFCE00","d":"M0 2h5v1H0z"}})])
          )
        }
      }
    